<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">用户管理</span></div>
		<div class="margin-top margin-left margin-right">
			<input type="text" v-model="name" placeholder="输入姓名/昵称/手机号搜索" style="width: 240px;"
				   @keyup.enter="doSearch"/>
			<Button color="primary" :loading="loading" @click="doSearch">搜索</Button>
			<Button @click="exportAll">导出</Button>
		</div>
		<div class="h-panel-body">
			<Table :datas="dataList" :loading="loading">
				<TableItem prop="id" title="ID" :width="70"/>
				<TableItem prop="mobile" title="手机号" :width="130"/>
				<TableItem prop="realName" title="真实姓名"/>
				<TableItem prop="nickname" title="昵称"/>
				<TableItem prop="email" title="邮箱"/>
				<TableItem title="状态" :width="80" align="center">
					<template slot-scope="{data}">
						<span :class="data.status === 0 ? 'red-color' : 'green-color'">{{ data.status === 0 ? '已禁用' : '正常' }}</span>
					</template>
				</TableItem>
				<TableItem title="注册时间" :width="150">
					<template slot-scope="{data}">
						{{ data.createDate ? moment(data.createDate).format('YYYY-MM-DD HH:mm') : '' }}
					</template>
				</TableItem>
				<TableItem title="操作" :width="180" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="toggleStatus(data)">{{ data.status === 0 ? '启用' : '禁用' }}</span>
						<span @click="openResetPwd(data)">重置密码</span>
						<span @click="openAccountSets(data)">账套</span>
					</div>
				</TableItem>
			</Table>
			<Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
						@change="loadList" small align="right"/>
		</div>

		<!-- 重置密码 -->
		<Modal v-model="showResetPwd" hasCloseIcon>
			<div slot="header">重置密码 - {{ currentRow.realName || currentRow.mobile }}</div>
			<Form :labelWidth="90" ref="pwdForm" :rules="pwdRules" :model="pwdForm">
				<FormItem label="新密码" prop="password">
					<input type="text" v-model="pwdForm.password" maxlength="32" placeholder="请输入新密码"/>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="showResetPwd=false">取消</Button>
				<Button color="primary" :loading="saving" @click="doResetPwd">确定</Button>
			</div>
		</Modal>

		<!-- 用户名下账套 -->
		<Modal v-model="showAccountSets" hasCloseIcon :width="640">
			<div slot="header">名下账套 - {{ currentRow.realName || currentRow.mobile }}</div>
			<Table :datas="userAccountSets" :loading="asLoading">
				<TableItem prop="id" title="ID" :width="70"/>
				<TableItem prop="companyName" title="单位名称"/>
				<TableItem title="角色" :width="100">
					<template slot-scope="{data}">{{ rolesMap[data.role] || data.role }}</template>
				</TableItem>
				<TableItem title="状态" :width="80" align="center">
					<template slot-scope="{data}">
						<span :class="data.status === 0 ? 'red-color' : 'green-color'">{{ data.status === 0 ? '已停用' : '启用' }}</span>
					</template>
				</TableItem>
				<TableItem title="到期时间" :width="110">
					<template slot-scope="{data}">
						{{ data.expireDate ? moment(data.expireDate).format('YYYY-MM-DD') : '未设置' }}
					</template>
				</TableItem>
			</Table>
		</Modal>
	</app-content>
</template>

<script>
	import moment from 'moment';

	export default {
		name: "AdminUsers",
		data() {
			return {
				loading: false,
				saving: false,
				name: '',
				dataList: [],
				pagination: {
					page: 1,
					size: 20,
					total: 0
				},
				//重置密码
				showResetPwd: false,
				currentRow: {},
				pwdForm: {password: ''},
				pwdRules: {required: ['password']},
				//名下账套
				showAccountSets: false,
				userAccountSets: [],
				asLoading: false,
				rolesMap: {Manager: '账套管理员', Director: '主管', Making: '制单人', Cashier: '出纳', View: '查看', BOSS: '平台管理员'}
			}
		},
		methods: {
			moment,
			loadList() {
				this.loading = true;
				this.$api.admin.users({
					page: this.pagination.page,
					size: this.pagination.size,
					name: this.name || undefined
				}).then(({data}) => {
					this.dataList = data.records || [];
					this.pagination.total = Number(data.total || 0);
				}).finally(() => this.loading = false);
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			},
			exportAll() {
				window.open(this.$api.admin.usersExportUrl({name: this.name || undefined}));
			},
			toggleStatus(data) {
				let next = data.status === 0 ? 1 : 0;
				let tip = next === 1 ? `确认启用用户【${data.realName || data.mobile}】？` : `确认禁用用户【${data.realName || data.mobile}】？禁用后该用户将无法登录。`;
				this.$Confirm(tip).then(() => {
					this.$api.admin.updateUserStatus({id: data.id, status: next}).then(() => {
						this.$Message.success(next === 1 ? '已启用' : '已禁用');
						this.loadList();
					});
				});
			},
			openResetPwd(data) {
				this.currentRow = data;
				this.pwdForm = {password: ''};
				this.showResetPwd = true;
			},
			doResetPwd() {
				if (!this.$refs.pwdForm.valid().result) {
					return;
				}
				this.saving = true;
				this.$api.admin.resetUserPassword({id: this.currentRow.id, password: this.pwdForm.password}).then(() => {
					this.$Message.success('密码已重置');
					this.showResetPwd = false;
				}).finally(() => this.saving = false);
			},
			openAccountSets(data) {
				this.currentRow = data;
				this.showAccountSets = true;
				this.asLoading = true;
				this.$api.admin.userAccountSets(data.id).then(({data: list}) => {
					this.userAccountSets = list || [];
				}).finally(() => this.asLoading = false);
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>

<style lang="less" scoped>
	.actions {
		span {
			color: #1890ff;
			cursor: pointer;
			margin: 0 6px;

			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>
